export default "__VITE_ASSET__bDzzmtLt__"